import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Title-case a human name. Splits on whitespace and hyphens, uppercases
 * each leading letter, lowercases the rest. Defensive against empty
 * strings, null, and already-titled input. Not for arbitrary text — keep
 * to identifiers and display names.
 */
export function titleCaseName(input: string | null | undefined): string {
  if (!input) return '';
  return input
    .trim()
    .split(/(\s+|-)/)
    .map((part) => {
      if (!part || /^\s+$/.test(part) || part === '-') return part;
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join('');
}
